var en = {
  DROPDOWN_OPTIONS_ERASE_ALL: 'Erase all',
  DROPDOWN_OPTIONS_BACK_BUTTON: 'Back',
  DROPDOWN_EMPTY_TITLE: 'No results found',
  DROPDOWN_EMPTY_SUBTITLE: 'Try a more general keyword',
  DROPDOWN_SEARCH_PLACEHOLDER: 'Search',
  DROPDOWN_LOADING: 'Loading...',
  DROPDOWN_ERROR_TITLE: 'Error loading data',
  DROPDOWN_ERROR_DESCRIPTION: 'There was a problem loading the information. Please try again.',
  DROPDOWN_ERROR_RETRY: 'Retry'
};
export default en;